
        require('./index.scss');
        'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _feedback = require('model/service/feedback.js');

var _feedback2 = _interopRequireDefault(_feedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _module = {
    $mod: $('.module-right-toolbar'),
    cityId: $('.module-right-toolbar').data('cityid'),
    ismp: $('.module-right-toolbar').data('mp'),
    share: $('.share').find('div'),
    contactInfo: {
        cityId: $('.module-right-toolbar').data('cityid'),
        opca: $('.module-right-toolbar').data('opca'),
        pname: $('.module-right-toolbar').data('pname'),
        source: $('.module-right-toolbar').data('source'),
        infoid: $('.module-right-toolbar').data('infoid'),
        ismp: $('.module-right-toolbar').data('mp'),
        hotlinePhone: $('.module-right-toolbar').data('hotlinePhone'),
        contactMail: $('.module-right-toolbar').data('contactMail')
    },

    init: function init() {
        this.bindScroll();
        this.bindClick();
        // this.bindHover();
        this.updateConnectPhone();
    },
    updateConnectPhone: function updateConnectPhone() {
        _feedback2['default'].getHome400().then(function (res) {
            $('.connect').find('.hover-tips .text').text(res.data.prefix + '\u8F6C' + res.data.suffix);
        });
    },

    bindScroll: function bindScroll() {
        var that = this;
        var winHeight = $(window).height();
        var infoFix = _.throttle(function () {
            if ($(window).scrollTop() > 0) {
                that.$mod.removeClass('hide').addClass('show');
            } else {
                that.$mod.removeClass('show').addClass('hide').find('.rt-item').removeClass('active');
                Event.trigger('shopping-cart', 'shopping-cart-unfold');
            }
        });
        $(window).scroll(infoFix);
    },
    bindClick: function bindClick() {
        var _this = this;

        var that = this;

        this.$mod.find('.ruzhu').click(function () {
            Event.trigger('feedback-dialog_show', 'ruzhu', that.contactInfo);
        });

        this.$mod.find('.feedback').click(function () {
            Event.trigger('feedback-dialog_show', 'feedback', that.contactInfo);
        });

        this.$mod.find('.design').click(function () {
            Event.trigger('design-block-show');
        });

        this.$mod.find('.cal').click(function () {
            Event.trigger('cal-block-show');
        });

        this.$mod.find('.gotop').click(function () {
            $('html,body').animate({
                scrollTop: 0
            }, 300);
        });

        var _loop = function _loop(i) {
            _this.share[i].addEventListener('click', function () {
                var type = that.share[i].id;
                var URL = window.location.href;
                var TITLE = window.document.title;
                var DESC = $(document.head).find('[name="description"]').attr('content');
                var SUMMARY = $(document.head).find('[name="keywords"]').attr('content');
                var SOURCE = window.location.href;
                var IMAGE = ''; // TODO: 头图
                switch (type) {
                    case 'qzone':
                        console.log('open qzone');
                        window.open('http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + URL + '&title=' + TITLE + '&desc=' + DESC + '&summary=' + SUMMARY + '&site=' + SOURCE + '&pics=' + IMAGE);
                        break;
                    case 'weibo':
                        console.log('open weibo');
                        window.open('http://service.weibo.com/share/share.php?url=' + URL + '&title=' + DESC + '&pic=' + IMAGE);
                        break;
                    case 'QQ':
                        console.log('open qq');
                        window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + URL + '&title=' + TITLE + '&source=' + SOURCE + '&desc=' + DESC + '&pics=' + IMAGE + '&summary=' + SUMMARY);
                        break;
                    default:
                        console.log('unmatched');
                }
            });
        };

        for (var i = 0; i < 3; i++) {
            _loop(i);
        }
    }
};

_module.init();

exports['default'] = _module;;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/right-toolbar/index.js